/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useCallback } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import customStyles from "../../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/actions";
import { Link } from "react-router-dom";
import clsx from "clsx";

const UniversalCatalogue = (props) => {
    const { catalogueDetails, catalogueLoader } = useSelector(state => state.younoteAdminProductReducer);

    const dispatch = useDispatch();
    useEffect(() => {
        loadTasks();
        return () => {
            dispatch({ type: actions.CLEAR_ADMIN_PRODUCT_DETAILS_START });
        }
    }, []);

    const loadTasks = useCallback(() => {
        dispatch({
            type: actions.CATALOGUE_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
    });

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Younote Admin'} links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Universal Catalogue', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.universalCatalogue)}>
                <PrimaryCard
                    title={'Universal Catalogue'}
                    component={
                        <div className={clsx(classes.catalogue)}>
                            <div className={classes.subBreadcrumb}>
                                Home
                            </div>
                            {
                                catalogueLoader || catalogueDetails === '' ? (
                                    <div className={classes.loadMoreCircle}></div>
                                ) : (
                                    <div className={clsx(classes.row)}>
                                        {
                                            catalogueDetails && Array.isArray(catalogueDetails) && catalogueDetails.length > 0 ? catalogueDetails.map((data, i) => (
                                                <div key={i} className={clsx(classes.colInline, classes.margin40t)}>
                                                    <div className={clsx(classes.categoryListLink)}>
                                                        <Link to={`/younote-admin/common/universal-catalogue/${data.id}/view`}>
                                                            <div className={clsx(classes.catalogueTitle)}>{data?.catalogueName}</div>
                                                            <div className={clsx(classes.catalogueDesign)}>
                                                                <div className={clsx(classes.catalogueDesign2)}></div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            )) : (
                                                <div className={clsx(classes.noResults)}>
                                                    <div className={clsx(classes.noResultsText)}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></div>
                                                </div>
                                            )
                                        }
                                    </div>
                                )
                            }
                        </div>
                    }
                />
            </div>
        </React.Fragment >
    )
}


export default UniversalCatalogue;